export default __webpack_public_path__ + "static/media/iziq_full.38066d33.png";